<template>
  <ion-menu side="start" swipe-gesture="false" content-id="main-content">
    <ion-header>
      <ion-toolbar color="navbar">
        <ion-title>Menu</ion-title>
      </ion-toolbar>
    </ion-header>
    <ion-content>
      <ion-list v-if="user">
        <ion-list-header>
          <ion-label>Version</ion-label>
        </ion-list-header>
        <ion-item>
          <ion-icon slot="start" ios="ios-phone-portrait" md="md-phone-portrait"></ion-icon>
          <ion-label>{{ version }}</ion-label>
        </ion-item>
        <ion-item v-if="user.upgraded == null || user.upgraded == ''">
          <ion-icon slot="start" ios="ios-ribbon" md="md-ribbon"></ion-icon>
          <ion-label>Free</ion-label>
        </ion-item>
        <ion-item v-if="user.upgraded && user.upgraded.length > 0">
          <ion-icon slot="start" ios="ios-ribbon" md="md-ribbon"></ion-icon>
          <ion-label>Paid</ion-label>
        </ion-item>
        <ion-item button tappable detail="true" @click="upgradeAccount" v-if="user.upgraded == null || user.upgraded == ''">
          <ion-icon slot="start" ios="ios-cart" md="md-cart"></ion-icon>
          <ion-label>Upgrade</ion-label>
        </ion-item>
        <ion-list-header>
          <ion-label>Profile</ion-label>
        </ion-list-header>
        <ion-item>
          <ion-icon slot="start" ios="ios-person" md="md-person"></ion-icon>
          <ion-label>{{ user.name }}</ion-label>
        </ion-item>
        <ion-item>
          <ion-icon slot="start" ios="ios-mail" md="md-mail"></ion-icon>
          <ion-label>{{ user.email }}</ion-label>
        </ion-item>
        <ion-item button tappable detail="true" @click="userLogout">
          <ion-icon slot="start" ios="ios-log-out" md="md-log-out"></ion-icon>
          <ion-label>Logout</ion-label>
        </ion-item>
      </ion-list>
    </ion-content>
  </ion-menu>
</template>

<script>
import Helpers from "../mixins/Helpers";
import Plugins from "../mixins/Plugins";
import { version } from "../../package.json";
import User from "../models/User";
import UserUpgrade from "./UserUpgrade.vue";
export default {
  name: "side-menu",
  mixins: [Helpers, Plugins],
  data() {
    return {
      platform: "web",
      version: version
    };
  },
  computed: {
    user() {
      return this.$store.getters.getUser();
    }
  },
  async created() {
    let device = (await this.deviceInfo()) || {};
    this.platform = device.platform;
  },
  async mounted() {},
  methods: {
    async userLogout() {
      let loading = await this.showLoading("Logging out...");
      try {
        await this.$store.dispatch("userLogout");
        await this.clearStorage();
        await this.closeMenu();
        this.showRootPage("login");
      } catch (error) {
        this.showWarning(error);
      } finally {
        loading.dismiss();
      }
    },
    async upgradeAccount() {
      await this.showModal(UserUpgrade);
    }
  }
};
</script>

<style scoped>
.list-md {
  margin-top: 0;
  padding-top: 0;
}
</style>
